/**
 * Enum loại nghiệp vụ KB điện tử (cho Kết xuất xml)
 * dtnga3 (22.11.2022)
 */
export default {
  BUPlanWithdrawTransfer: 1,
  BUPlanWithdrawSalaryTransfer: 2,
  BUPlanWithdrawDeposit: 3,
  BUPlanWithdrawCash: 4,
  CAReceiptWithdraw: 5,
  EMoneyTransfer: 6,
  PUInvoice: 7,
  BUForeignPlanWithdrawTransfer: 12,
  BUForeignPlanWithdrawCash: 13,
  BUInvestmentWithdrawTransfer: 14,
  BUInvestmentWithdrawCash: 15,
  BUInvestment: 16,
  PayFees: 8,
};
